
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/[...slug]",
      function () {
        return require("private-next-pages/discover/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/[...slug]"])
      });
    }
  